import React, { useState, useEffect } from "react";
import { Menu, X, ShoppingBag } from "lucide-react";
import { ORDER_LINKS } from "../data/menu";

const NAV_LINKS = [
  { label: "Menu", href: "#menu", testid: "nav-menu" },
  { label: "Boxes", href: "#boxes", testid: "nav-boxes" },
  { label: "Drinks", href: "#drinks", testid: "nav-drinks" },
  { label: "Our Story", href: "#story", testid: "nav-story" },
  { label: "Visit", href: "#visit", testid: "nav-visit" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#FFFDFB]/85 backdrop-blur-xl border-b border-[#FFB3C6]/30 py-2.5 sm:py-3"
          : "bg-transparent py-3 sm:py-5"
      }`}
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8 flex items-center justify-between gap-3">
        <a href="#top" data-testid="brand-logo" className="flex items-center gap-2 group">
          <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-full bg-[#FF6392] text-white shadow-[0_4px_18px_rgba(255,99,146,0.45)]">
            <span className="absolute inset-1 rounded-full border-2 border-white/70" />
            <span className="relative font-serif-display text-base leading-none">D</span>
          </span>
          <div className="leading-tight">
            <div className="font-serif-display text-lg sm:text-xl text-[#2D2327] tracking-tight">Don Donuts</div>
            <div className="hidden sm:block text-[10px] uppercase tracking-[0.22em] text-[#FF6392]">McAllen · 956</div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="px-4 py-2 text-sm font-medium text-[#2D2327]/80 hover:text-[#FF6392] transition-colors rounded-full"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={ORDER_LINKS.orderOnline}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="navbar-order-button"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-[#FF6392] text-white px-5 py-2.5 text-sm font-semibold hover:bg-[#E84A7A] hover:-translate-y-0.5 transition-all shadow-[0_6px_20px_rgba(255,99,146,0.35)]"
          >
            <ShoppingBag className="h-4 w-4" />
            Order Online
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="mobile-menu-toggle"
            className="lg:hidden inline-flex items-center justify-center h-11 w-11 rounded-full border border-[#FFB3C6]/60 bg-white/80"
            aria-label="Toggle menu"
          >
            {open ? <X className="h-5 w-5 text-[#2D2327]" /> : <Menu className="h-5 w-5 text-[#2D2327]" />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu-panel" className="lg:hidden border-t border-[#FFB3C6]/30 bg-[#FFFDFB]/95 backdrop-blur-xl">
          <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-${l.testid}`}
                className="px-3 py-3 rounded-xl text-[#2D2327] hover:bg-[#FFF0F3]"
              >
                {l.label}
              </a>
            ))}
            <a
              href={ORDER_LINKS.orderOnline}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="mobile-order-button"
              className="mt-2 inline-flex justify-center items-center gap-2 rounded-full bg-[#FF6392] text-white px-5 py-3 font-semibold"
            >
              <ShoppingBag className="h-4 w-4" /> Order Online
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
